import { type PayoutItem, PayoutItemMethodEnum } from "libs/codegen/property-onboarding";

export enum PayoutMode {
    Existing,
    Create,
}

export const payoutMethodMapper = {
    VirtualCardSingle: PayoutItemMethodEnum.NUMBER_3,
    VirtualCardMultiple: PayoutItemMethodEnum.NUMBER_5,
    BankTransfer: PayoutItemMethodEnum.NUMBER_1,
    PhysicalCard: PayoutItemMethodEnum.NUMBER_2,
    PayPal: PayoutItemMethodEnum.NUMBER_6,
};

export type NewPayoutMethod = "UPCSingle" | "UPCMultiple" | "ECard" | "Bank" | "PayPal";

export const newPayoutItem: Record<NewPayoutMethod, Omit<PayoutItem, "name">> = {
    UPCSingle: {
        id: -1,
        trailingNumber: null,
        method: payoutMethodMapper.VirtualCardSingle,
    },
    UPCMultiple: {
        id: -2,
        trailingNumber: null,
        method: payoutMethodMapper.VirtualCardMultiple,
    },
    ECard: {
        id: -4,
        trailingNumber: null,
        method: payoutMethodMapper.PhysicalCard,
    },
    Bank: {
        id: -3,
        trailingNumber: null,
        method: payoutMethodMapper.BankTransfer,
    },
    PayPal: {
        id: -5,
        trailingNumber: null,
        method: payoutMethodMapper.PayPal,
    },
};
